import { render } from "./ResultatDossier.vue?vue&type=template&id=25f5ac8f&scoped=true"
import script from "./ResultatDossier.vue?vue&type=script&lang=js"
export * from "./ResultatDossier.vue?vue&type=script&lang=js"

import "./ResultatDossier.vue?vue&type=style&index=0&id=25f5ac8f&scoped=true&lang=css"

import exportComponent from "/data/opt/gitlab-runner/working-directory/podman-stable_v4.8.1/corpo/crp-cardex-webapp/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f5ac8f"]])

export default __exports__